module.exports = __webpack_public_path__ + "assets/img/tx15s.7a8b65ae.jpg";